<div *ngIf="isLoading" class="shade">
  <img class="preloader" [src]="src" />
</div>
